import React from 'react';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { useTheme } from 'styled-components';
import {
  Container,
  PercentageText,
  ProgressBarFiller,
  ProgressBar as StyledProgressBar,
} from './ProgressBar.styles';

export interface ProgressBarProps {
  /**
   * Percentage of progress complete (number only, ex: 50).
   */
  percentage: number;
  'data-testid'?: string;
  error?: boolean;
  barWidth?: string;
}

/**
 * Show the user's progression through a flow.
 */
export const ProgressBar: React.FC<ProgressBarProps> = ({
  percentage = 0,
  error,
  barWidth,
  ...props
}: ProgressBarProps) => {
  const theme = useTheme();
  return (
    <Container>
      <StyledProgressBar data-testid={props['data-testid']} barWidth={barWidth}>
        <ProgressBarFiller
          percentage={percentage}
          error={error}
          data-testid="progress-bar-filler"
        />
      </StyledProgressBar>
      {percentage >= 100 ? (
        <StyledIcon
          className="uil uil-check"
          data-testid="progress-check"
          color={theme.atlas.semantic.color.type.default}
          size="24px"
        />
      ) : (
        <PercentageText>{percentage}%</PercentageText>
      )}
    </Container>
  );
};

export default ProgressBar;
